import { ErrorMessage, Field, Form, Formik } from 'formik';

import React from 'react';
import { Card } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {myFirestore} from '../../../services/firebase'
import * as Yup from 'yup';

import './intakeform1.css';


class IntakeForm1 extends React.Component {
  constructor(props) {
    super(props)
    
    this.uid=this.props.auth.uid;
    
  }
  


  saveform=(fields)=>{
    console.log(fields,this.uid)
    myFirestore
            .collection('intakeform1')
            .doc(this.uid)
            .set({
              id:this.uid,
              symptoms:fields.symptoms,
              isConsent:fields.isConsent,
              treatmentGoals:fields.treatmentGoals,
              currentIssues:fields.currentIssues

            },
            { merge: true })
            .then(() => {
                 
                 this.props.history.push('/peerchat')

                 
            })
            .catch(err => {
                this.props.showToast(0, err.toString())
            })
    
  }

  handleSubmit = (values, {
    setSubmitting
  }) => {

    alert(JSON.stringify(values, null, 2));

    setSubmitting(false);

    return;
  }


  render() {
    const { auth } = this.props;
    if (!auth.uid) return <Redirect to='/signin' />
    
    return (
      <>
        <Formik
          initialValues={{

            currentIssues: '',

            isConsent: true,
            treatmentGoals: '',
            symptoms:[],
            frequencyOfUsage:'',
            substanceUse:[],
            other:false,
            otherSubstance:'',
            feelings:'',

          }}
          validationSchema={Yup.object().shape({


            currentIssues: Yup.string()
              .required('Current Issues are required'),
            isConsent: Yup.bool(),
            treatmentGoals: Yup.string()
              .required('Treatment Goals are required'),
          })}
          onSubmit={fields => {


            this.saveform(fields);

          }}

        >
          {({ errors, touched, values }) => (



            <Container className="form-container" fluid>
              

              <Card className="form-card">
                <h2 style={{ fontWeight: 'bolder',padding:'1rem' }}>Before we connect you with a peer,
              could you help us with a little more information?</h2>
                <h5 style={{ color: 'grey',fontWeight: 'thin',padding:'1rem'  }}>
                  Disclaimer : This information will remain completely confidential and
                  will only be used in order to improve your Peer Counselling experience with us.
            <br></br>
                    If you choose, you can consent to contributing this data for research and
              for improving Secureस्थल over time as a tool for students' mental health and well being.
            </h5>
                <Form>

                  <div className="form-group form-check form-consent card ">
                    <Field type="checkbox" name="isConsent" className={'form-check-input ' + (errors.isConsent && touched.isConsent ? ' is-invalid' : '')} />
                    <label htmlFor="isConsent" className="form-check-label">Yes, I consent to providing this information for research purposes.</label>
                    <ErrorMessage name="isConsent" component="div" className="invalid-feedback" />

                  </div>


                  <div className="form-group ">
                    <label htmlFor="currentIssues">What are the current issues you are facing?  </label>
                    <Field name="currentIssues" type="text" className={'form-control' + (errors.currentIssues && touched.currentIssues ? ' is-invalid' : '')} />
                    <ErrorMessage name="currentIssues" component="div" className="invalid-feedback" />
                  </div>


                  <div className="form-group">
                    <label htmlFor="treatmentGoals">What are your expectations from this session? </label>
                    <Field name="treatmentGoals" type="text" className={'form-control' + (errors.treatmentGoals && touched.treatmentGoals ? ' is-invalid' : '')} />
                    <ErrorMessage name="treatmentGoals" component="div" className="invalid-feedback" />
                  </div>
                  <div className="form-group ">
                    <label htmlFor="text">Are you currently experiencing any of these things?</label>
                  </div>
                  <div className='row justify-content-center'>
                    <div className='col justify-content-center'>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Unable to enjoy activities' className={'form-check-input '} />
                        <label htmlFor="isConsent" className="form-check-label">Unable to enjoy activities </label>
                        <ErrorMessage name="isConsent" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms"  value='Concentration/ forgetfulness' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Concentration/ forgetfulness</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms"  value='Loss of motivation' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Loss of motivation</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Depressed mood' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Depressed mood</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Change in appetite' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Change in appetite</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Increased sexual drive' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Increased sexual drive</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Impulsivity' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Impulsivity</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Racing thoughts' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Racing thoughts</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Excessive guilt' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Excessive guilt </label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Anxiety attacks' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Anxiety attacks</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Suspiciousness' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Suspiciousness</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Thoughts of Suicide' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Thoughts of Suicide</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                    <div className='col'>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Loss of interest' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Loss of interest </label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Fatigue' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Fatigue</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Increased irritability' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Increased irritability</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Sleep pattern disturbance' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Sleep pattern disturbance</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Excessive energy' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Excessive energy</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Decreased sexual drive' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Decreased sexual drive</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Increase risky behaviour' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Increase risky behaviour</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Changes in sleep patterns' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Changes in sleep patterns</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Excessive worry' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Excessive worry </label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Crying spells' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Crying spells</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Hallucinations' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Hallucinations</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="symptoms" value='Sexual Violence' className={'form-check-input '} />
                        <label htmlFor="symptoms" className="form-check-label">Sexual Violence</label>
                        <ErrorMessage name="symptoms" component="div" className="invalid-feedback" />
                      </div>
                      
                      
                    </div>

                  </div>
                  <div className="form-group">
                    <label htmlFor="feelings">Do you currently or have you ever had feelings or thoughts that you didn't want to live?</label>
                    <Field name="feelings" type="text" className={'form-control' + (errors.feelings && touched.feelings ? ' is-invalid' : '')} />
                    <ErrorMessage name="feelings" component="div" className="invalid-feedback" />
                  </div>
                  <div className="form-group ">
                    <label htmlFor="text">Substance Use:</label>

                    <div className='row form-group'>

                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="substanceUse" value='Alcohol' className={'form-check-input '} />
                        <label htmlFor="substanceUse" className="form-check-label">Alcohol</label>
                        <ErrorMessage name="substanceUse" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="substanceUse" value='Cigarettes' className={'form-check-input '} />
                        <label htmlFor="substanceUse" className="form-check-label">Cigarettes</label>
                        <ErrorMessage name="substanceUse" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="substanceUse" value='Marijuana' className={'form-check-input '} />
                        <label htmlFor="substanceUse" className="form-check-label">Marijuana</label>
                        <ErrorMessage name="substanceUse" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group form-check  ">
                        <Field type="checkbox" name="other" className={'form-check-input '} />
                        <label htmlFor="other" className="form-check-label">Other</label>
                        <ErrorMessage name="other" component="div" className="invalid-feedback" />

                      </div>
                      {values.other &&
                        <div className="form-group">

                          <Field name="othersubstance" type="text" className={'form-control' + (errors.othersubstance && touched.othersubstance ? ' is-invalid' : '')} />
                          <ErrorMessage name="othersubstance" component="div" className="invalid-feedback" />
                        </div>
                      }


                    </div>


                  </div>
                  <div className="form-group">
                    <label htmlFor="frequencyOfUsage">Frequency of usage :</label>
                    <Field name="frequencyOfUsage" type="text" className={'form-control' + (errors.frequencyOfUsage && touched.frequencyOfUsage ? ' is-invalid' : '')} />
                    <ErrorMessage name="frequencyOfUsage" component="div" className="invalid-feedback" />
                  </div>



                  <div className="row justify-content-center">

                    <button type="submit" className="btn button mr-2 ">Proceed </button>
                    <button type="reset" className="btn" style={{ width: '15rem', borderColor: '#40817a', borderRadius: '1rem', margin: '0.2rem' }}>Reset</button>
                  </div>

                </Form>
              </Card>

            </Container>





          )}

        </Formik>
      </>
    );
  }
  
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    authError: state.auth.authError
  }
}



export default connect(mapStateToProps)(IntakeForm1)
